module.exports = __webpack_public_path__ + "static/media/Lens-Fresh_Green_TW.52269510.png";